import React from "react";
import ConnexingLoadingIndicatorBlue from "../../../ShareElements/LoadingIndicator/ConnexingLoadingIndicatorBlue";

const ScreenOverlay = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  const switchStatus = (Status) => {
    switch (Status) {
      case "IN_PROGRESS":
        return <p className="status">{translateText("in_progress")} ...</p>;
      case "COMPLETED":
        return <p className="status done">{translateText("done")}</p>;
      case "STOPPED":
        return <p className="status failed">{translateText("failed")}</p>;
    }
  };
  const shortenText = (State) => {
    if (State.length < 25) {
      return State;
    } else {
      return State.slice(0, 25) + "...";
    }
  };

  const displayStagingLogs = (LogItem) => {
    let LogsToSearch = props.StagingLogs;
    if (LogItem.status === "COMPLETED") {
      let IndexToRemove = parseInt(LogsToSearch.indexOf(LogItem) + 1);
      let IdToRemove = LogsToSearch[IndexToRemove].id;
      if (document.getElementById(IdToRemove) !== null) {
        document.getElementById(IdToRemove).style.display = "none";
      }
    }
    return (
      <div className="detail-row" id={LogItem.id} key={LogItem.id}>
        <p className="csv-name">{shortenText(LogItem.state) + " Staging "}</p>
        {switchStatus(LogItem.status)}
      </div>
    );
  };

  const displayBaseLogs = (LogItem) => {
    let LogsToSearch = props.BaseLogs;
    if (LogItem.status === "COMPLETED") {
      let IndexToRemove = parseInt(LogsToSearch.indexOf(LogItem) + 1);
      let IdToRemove = LogsToSearch[IndexToRemove].id;
      if (document.getElementById("base-" + IdToRemove) !== null) {
        document.getElementById("base-" + IdToRemove).style.display = "none";
      }
    }
    return (
      <div className="detail-row" id={"base-" + LogItem.id} key={LogItem.id}>
        <p className="csv-name">{shortenText(LogItem.state) + " Base "}</p>
        {switchStatus(LogItem.status)}
      </div>
    );
  };

  return (
    <div className="screen-overlay">
      <div className="overlay-body">
        <section className="overlay-head">
          <h1>{translateText("staging_and_base_transfer")}</h1>
        </section>
        <section className="rotator">
          <ConnexingLoadingIndicatorBlue/>
        </section>
        <section className="details">
          <p className="detail-label">{translateText("progress_details")}</p>
          <div className="detail-body">
            <p className="detail-label-small">
              {translateText("staging_progress")}
            </p>
            {props.StagingLogs.map((LogItem) => (
              <React.Fragment>
                {LogItem.state.length === 0 ||
                LogItem.state.length === 0 ? null : (
                  <React.Fragment>{displayStagingLogs(LogItem)}</React.Fragment>
                )}
              </React.Fragment>
            ))}
            <React.Fragment>
              {props.BaseLogs.length === 0 ? null : (
                <React.Fragment>
                  <p className="detail-label-small">
                    {translateText("data_import_base_transfer_progress")}
                  </p>
                  {props.BaseLogs.map((LogItem) => (
                    <React.Fragment>
                      {LogItem.state.length === 0 ||
                      LogItem.state.length === 0 ? null : (
                        <React.Fragment>
                          {displayBaseLogs(LogItem)}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              )}
            </React.Fragment>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ScreenOverlay;
